import { render, staticRenderFns } from "./BaseSearchForm.vue?vue&type=template&id=0635b708&scoped=true&"
import script from "./BaseSearchForm.vue?vue&type=script&lang=js&"
export * from "./BaseSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchForm.vue?vue&type=style&index=0&id=0635b708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0635b708",
  null
  
)

export default component.exports